import { InjectionToken } from '@angular/core';

export interface AppSettings {
    apiBaseUrl: string;
    securedUrls: string[]
}

export const APP_SETTINGS = new InjectionToken<AppSettings>('APP_SETTINGS');

let RUNTIME_APP_SETTINGS: AppSettings = {
    apiBaseUrl: '/api',
    securedUrls: ['/api','/plan/']
};

export function setAppSettings(config: Partial<AppSettings>): void {
    RUNTIME_APP_SETTINGS = { ...RUNTIME_APP_SETTINGS, ...config } as AppSettings;
}

export function getAppSettings(): AppSettings {
    return RUNTIME_APP_SETTINGS;
}

export function appSettingsInitializer(): () => Promise<void> {
    return async () => {
        try {
            const response = await fetch('./assets/config/app-settings.json', { cache: 'no-store' });
            if (response.ok) {
                const json = await response.json();
                setAppSettings(json);
            }
        } catch {
            // fallback to defaults if fetch fails
        }
    };
}
